import React from 'react';

const TicketItem = ({ event, ticket }) => (
    <div className="ticket-info">
        <h5 className="event_listing_title">{ticket.name} at {event.title}</h5>
        <div className="event_listing_date "><i className="bi bi-calendar me-1"></i> {event.startDateTime}</div>
        <div className="event_listing_location"><i className="bi bi-geo-alt me-1"></i> {event.location}</div>
        <div className="event_listing_seat"><i className="bi bi-tag me-1"></i>{ticket.seat}</div>
    </div>

);
export default TicketItem;
